<template>
  <div>
    职务表
  </div>
</template>

<script>
export default {
  name: 'MoviePersonnel'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/MoviePersonnel.vue